$(document).ready(function() {

    if ($('.main-blog .paginate').find('.page:not(.disable)').length > 0)
        $('.main-blog .paginate').css('display', 'flex');
    else
        $('.main-blog .paginate').css('display', 'none');

    $(document).on('click', '.main-blog .paginate a', function(e) {
        e.preventDefault();

        let newUrl = $(this).attr('href');
        
        filterBLog(newUrl);

        $('html, body').animate({
            scrollTop: $('.main-blog').offset().top - 50
        }, 0);
    });

    $(document).on('click', '.tags .tag', function(e) {
        e.preventDefault();

        if ($(this).hasClass('active')) {
            $(this).addClass('active').siblings().removeClass('active');
        }
        else {
            $(this).removeClass('active');
        }

        let newUrl = $(this).attr('href');
        filterBLog(newUrl);
    });

    if ($('.article-list').length) {
        $('.article-list .owl-carousel').each(function() {
            let $carousel = $(this);
            let $floatNav = $carousel.next('.float-nav');

            let owl = $carousel.owlCarousel({
                items: 3,
                nav: false,
                dots: false,
                loop: false,
                autoHeight: false,
                smartSpeed: 800,
                margin: 20,
                responsive: {
                    0: {
                        items: 1,
                        dots: true,
                        loop: true
                    },
                    768: {
                        items: 2,
                        dots: true,
                        loop: true
                    },
                    1250: {
                        items: 3,
                        dots: true,
                        loop: false
                    }
                }
            });

            let img_h = $carousel.find('.article-image').height();
            $floatNav.css('top', `${img_h}px`);

            $floatNav.find('.owl-prev').on('click', function() {
                owl.trigger('prev.owl.carousel');
            });
            $floatNav.find('.owl-next').on('click', function() {
                owl.trigger('next.owl.carousel');
            });

            $(this).trigger('refresh.owl.carousel');
        });
    }

    article();
    faqs();

});

$(window).on('resize', function() {
    article();
    faqs();
});

function filterBLog(newUrl) {

    $.ajax({
        type: "GET",
        url: newUrl,
        success: function(data) {

            if ($(data).find('.articles').find('.article').length > 0) {
                $('.articles').html($(data).find('.articles').html());
            }

            if ($(data).find('.tags').find('.tag').length > 0) {
                $('.tags').html($(data).find('.tags').html());
            }
            
            $('.paginate').html($(data).find('.paginate').html());

            if ($(data).find('.paginate .page:not(.disable)').length > 0)
                $('.paginate').css('display', 'flex');
            else
                $('.paginate').css('display', 'none');
        },
        error: function() {
            console.log("Error occurred while filtering articles.");
        },
    });

    if (window.history && window.history.pushState) {
        window.history.pushState(null, null, newUrl);
    }
}

function article() {
    let headerH = $('.header-group').height();
    
    $('.main-article').css('margin-top', `${headerH}px`);
}

$('.main-article .copy').on('click', function () {
    const url = $(this).data('url');
    navigator.clipboard.writeText(url).then(() => {
        const popup = $('.copy-popup');
        popup.addClass('show');

        setTimeout(() => {
            popup.removeClass('show');
        }, 1000);
    });
});

function faqs() {
    let headerH = $('.header-group').height();
    
    $('.faqs').css('margin-top', `${headerH}px`);
}

$('.faqs [data-faq]').on('click', function(e) {
    e.preventDefault();
    let value = $(this).data('faq');
    let target = $('[data-acc="' + value + '"]');

    let headerH = $('.header-group').height();

    if (target.length) {
        $('html, body').animate({
            scrollTop: target.offset().top - headerH - 30
        }, 0);
    }
});